import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.messages')
  .factory('MessagesAPI', MessagesAPI);

function MessagesAPI(): BringozApi {
  return {
    base: `/messages/sms`,
    infiniteScroll: {
      address: `/messages/sms`,
      cmd: 'GET'
    },
    actions: {
      send: {
        address: '',
        cmd: 'POST',
        updateable: false
      },
      getTotals: {
        address: 'totals',
        cmd: 'GET',
        updateable: false
      }
    }
  }
}
